import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import { STRINGS, LANGS, type Lang } from '@tangazo/shared';
import { storage } from './storage';

// The shared Swahili/English strings use flat dotted keys and {name} placeholders.
void i18n.use(initReactI18next).init({
  resources: { sw: { translation: STRINGS.sw }, en: { translation: STRINGS.en } },
  lng: initialLang(),
  fallbackLng: 'sw',
  keySeparator: false,
  nsSeparator: false,
  returnObjects: true,
  interpolation: { escapeValue: false, prefix: '{', suffix: '}' },
});

function initialLang(): Lang {
  const q = new URLSearchParams(location.search).get('lang');
  if ((LANGS as readonly string[]).includes(q ?? '')) return q as Lang;
  const saved = storage.get('lang');
  return (LANGS as readonly string[]).includes(saved ?? '') ? (saved as Lang) : 'sw';
}

export function setLang(lang: Lang) {
  storage.set('lang', lang);
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
}

// t() for plain strings and tl() for lists (package features).
export function useT() {
  const { t, i18n: inst } = useTranslation();
  return {
    t: (key: string, vars?: Record<string, string | number>) => String(t(key, vars ?? {})),
    tl: (key: string) => {
      const v = t(key, { returnObjects: true }) as unknown;
      return Array.isArray(v) ? (v as string[]) : [];
    },
    tIn: (lang: string, key: string, vars?: Record<string, string | number>) => String(inst.getFixedT(lang)(key, vars ?? {})),
    lang: (inst.resolvedLanguage ?? 'sw') as Lang,
  };
}

export default i18n;
